<template>
  <draggable
    v-model="section.menus"
    tag="ul"
    class="list-group"
    handle=".drag-title">
    <li
      v-for="(menuItem, idx) in section.menus"
      v-show="showMenuItem(menuItem)"
      :key="menuItem.id"
      class="list-group-item">
      <div>
        <div class="drag-title">
          <span
            v-b-toggle="menuItem.id"
            class="pointer">
            <i :class="['fa', iconForMenuItem(menuItem)]" />
            {{ menuItem.name }}
          </span>
          <i
            class="fa fa-times close"
            @click="confirmRemoval({ id: menuItem.name }, () => removeMoreMenuItem(menuItem.id))" />
        </div>
        <b-collapse :id="menuItem.id">
          <div class="mt-3">
            <component
              :is="getComponentNameForMenuItem(menuItem)"
              v-model="section.menus[idx]"
              :constraint="imageConstraint"
              class="mt-3"
              @field-update="onComponentFieldUpdate" />
          </div>
        </b-collapse>
      </div>
    </li>
    <b-row>
      <b-col cols="6">
        <b-button
          class="mt-3"
          block
          variant="outline-primary"
          @click="addMoreMenuItem()">
          Add Menu Item
        </b-button>
      </b-col>
      <b-col cols="6">
        <b-button
          class="mt-3"
          block
          variant="outline-primary"
          @click="addMoreMenuApplicationPromo({ id })">
          Add App Item
        </b-button>
      </b-col>
    </b-row>
  </draggable>
</template>

<script>
  import uuid from 'uuid'
  import MoreMenuItem from '@/components/AppNavigation/MoreMenuItem'
  import MoreMenuApplicationPromo from '@/components/AppNavigation/MoreMenuApplicationPromo'
  import draggable from 'vuedraggable'
  import ConfirmRemoval from '@/mixins/ConfirmRemoval'
  import imageconstraints from "@/services/imageconstraints"

  export default {
    name: 'MoreMenuSection',
    components: {
        MoreMenuItem,
        MoreMenuApplicationPromo,
        draggable,
    },
    mixins: [ConfirmRemoval],
    props: {
        platform: {
          type: String,
          default: 'unfiltered',
        },
        device: {
          type: String,
          default: 'unfiltered',
        },
        id: {
            type: String,
            default: '',
        },
        section: {
          type: Object,
          required: true,
        },
    },
    computed: {
      imageConstraint() {
        switch (this.section.title.toUpperCase()) {
          case "SECTIONS":
            return imageconstraints.MoreMenuSections
          case "APPS & GAMES":
            return imageconstraints.MoreMenuAppsAndGames
          default:
            return {}
        }
      },
    },
    methods: {
      addMoreMenuItem() {
        const subId = uuid.v4()

        const menuItem = {
            id: subId,
            type: 'more-menu',
            phone: true,
            tablet: true,
            lite: true,
            paid: true,
            name: 'New Menu Item',
            imageURL: '',
            url: '',
            addAuthorizationHeader: false,
            appVersion: '',
            osVersion: '',
            entitlement: '',
            canonicalid: '',
            ios: true,
            android: true,
            scaleToFit: false,
            launchExternally: false,
            webView: '4',
        }

        this.section.menus.push(menuItem)
      },
      addMoreMenuApplicationPromo() {
        const subId = uuid.v4()

        const appItem = {
            id: subId,
            type: 'application-promo',
            phone: true,
            tablet: true,
            lite: true,
            paid: true,
            ios: true,
            android: true,
            name: 'New App Item',
            imageURL: '',
            packageiOS: '',
            packageAndroid: '',
            storeURLiOS: '',
            storeURLAndroid: '',
            intent: '',
            downloadText: '',
            cloudinary: false,
        }

        this.section.menus.push(appItem)

      },
      removeMoreMenuItem(menuId) {
          for (let i = 0; i < this.section.menus.length; i++) {
            const menu = this.section.menus[i]
            if (menu.id === menuId) {
              this.section.menus.splice(i, 1)
              break
            }
          }
      },
      onComponentFieldUpdate(data) {
          for (let i = 0; i < this.section.menus.length; i++) {
            const menu = this.section.menus[i]
            if (menu.id === data.id) {
              this.section.menus[i][data.field] = data.value
              break
            }
          }
      },
      iconForMenuItem(menuItem = {}) {
        return {
            'more-menu': 'fa-edit',
            'application-promo': 'fa-link',
        }[menuItem.type] || 'fa-question'
      },
      getComponentNameForMenuItem(menuItem = {}) {
        return {
            'more-menu': 'MoreMenuItem',
            'application-promo': 'MoreMenuApplicationPromo',
        }[menuItem.type]
      },
      onAssetSelect() {
          this.$refs.assetUploadModal.hide()
      },
      showMenuItem(menuItem) {
        const isActivePlatform = this.platform === 'unfiltered' || (this.platform === 'ios' ? menuItem.ios : menuItem.android)
        const isActiveDevice = this.device === 'unfiltered' || (((device) => menuItem[device])(this.device))
        return isActiveDevice && isActivePlatform
      },
    },
  }
</script>

<style scoped>
.RadioGroup--FullWidth {
  width: 100%;
}
</style>
